import React, { Component } from "react";
import "./Home.css";

export default class Home extends Component {
  render() {
    return (
<div className="Home">
	<div className="lander">
		<h1>BukHu</h1>
		<p>Share Your Treasure</p>
		
		
	</div>
</div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home.js